module.exports = __webpack_public_path__ + "img/首页流程图.c0f023ae.png";